import React from 'react';
import {
  AppBar,
  Box,
  Container,
  IconButton,
  MobileStepper,
  Paper,
  Toolbar,
  Typography,
  useTheme
} from '@mui/material';
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@mui/icons-material';
import { useAppContext } from '../context/AppContext';
import { BRANDING } from '../appConfig';

// Import all step components
import Income from '../components/Income';
import Expense from '../components/Expense';
import Debt from '../components/Debt';
import MutualFunds from '../components/MutualFunds';
import Equity from '../components/Equity';
import Others from '../components/Others';
import SubmitPage from '../components/SubmitPage';
import FundingStatusCard from "../components/results/FundingStatusCard";
import Global from '../components/Global';
import LifeGoalsForm from '../components/LifeGoalsForm'
import KidsPlanning from '../components/KidsPlanning';
import KidEducation from '../components/KidEducation';
import EmergencyFunds from '../components/EmergencyFunds';
import AssetDistribution from '../components/AssetDistribution'
import { SankyCharts } from '../components/SankyCharts';
import AnnualInvestments from '../components/AnnualInvestments';
import BirthYearForm from '../components/BirthYearForm';
import ExpensesInRetirementForm from '../components/ExpensesInRetirementForm';
import RiskProfileForm from '../components/RiskProfileForm';
import CurrentInvestmentForm from '../components/CurrentInvestmentForm';
import LastPage from '../components/LastPage';
// import Placeholder from '../components/PlaceHolder';
// import GenaralQuestions from '../components/GeneralQuestions';
import Employment from '../components/Employment';
import Experience from '../components/Experience';
// import PageThree from '../components/PageThree';

const QuestionaryPage = () => {
  const theme = useTheme();
  const { state, actions } = useAppContext();

  // All steps defined
  const getActiveSteps = () => {
    const steps = [
      { label: 'Birth Year', component: <BirthYearForm/>, key: 'birth' },
      { label: 'Retirement Expenses', component: <ExpensesInRetirementForm/> },
      { label: 'Kids', component: <KidsPlanning/>, key: 'kids' },
      ...(state.kidsInfo?.length > 0
        ? [{ label: 'Kids Education', component: <KidEducation formData={state} onChange={actions.updateFormData} /> }]
        : []),
      { label: 'Emergency', component: <EmergencyFunds/>, key: 'emergency' },
      { label: 'Goals', component: <LifeGoalsForm formData={state} onAddGoal={actions.addGoal} onRemoveGoal={actions.removeGoal} onChange={actions.updateFormData} />, key: 'goals' },
      { label: 'Risk Profile', component: <RiskProfileForm/>, key: 'risk' },
      { label: 'Net worth', component: <CurrentInvestmentForm/>, key: 'worth' },
      { label: 'Funding Status', component: <FundingStatusCard/>, key: 'funding' },
      { label: 'Submit', component: <SubmitPage/>, key: 'submit' },

      // Asset Allocation
      // { label: 'PlaceHolder', component: <Placeholder/>, key: 'placeholder' },
      { label: 'Income', component: <Income/>, key: 'income' },
      { label: 'Expense', component: <Expense/>, key: 'expense' },
      { label: "Annual Investments", component: <AnnualInvestments/>, key: 'investments' },
      { label: 'Debt', component: <Debt/>, key: 'debt' },
      { label: 'Mutual Funds', component: <MutualFunds/>, key: 'mutualFunds' },
      { label: 'Equity', component: <Equity/>, key: 'equity' },
      { label: 'Global', component: <Global/>, key: 'global' },
      { label: 'Others', component: <Others/>, key: 'others' },
      { label: 'Employment', component: <Employment/>},
      { label: 'Experience', component: <Experience/>},
      { label: 'Asset Distribution', component: <AssetDistribution/> },
      // { label: 'General Questionsry', component: <GenaralQuestions/> },
      // { label: 'PageThree', component: <PageThree/>},
      { label: 'Last Page', component: <LastPage/> },
      // { label: 'Sanky Charts', component: <SankyCharts/> }
    ];
    return steps;
  };

  const allSteps = getActiveSteps();

  // Divide based on label
  const goalPlanningSteps = allSteps.slice(0, allSteps.findIndex(step => step.label === 'Submit') + 1);
  const assetAllocationSteps = allSteps.slice(goalPlanningSteps.length);

  const currentSteps = state.stepperMode === 'goalPlanning' ? goalPlanningSteps : assetAllocationSteps;
  const currentTotalSteps = currentSteps.length;
  const currentStepIndex = state.stepperMode === 'goalPlanning'
    ? state.activeStep_goalPlanning
    : state.activeStep_assetAllocation;

  const handleNext = () => {
    state.stepperMode === 'goalPlanning' ? actions.nextStepGoal() : actions.nextStepAsset();
  };

  const handlePrev = () => {
    state.stepperMode === 'goalPlanning' ? actions.prevStepGoal() : actions.prevStepAsset();
  };

  const renderCurrentStep = () => {
    const currentStep = currentSteps[currentStepIndex];
    if (!currentStep) {
      return (
        <Box p={2}>
          <Typography variant="h6" color="error">
            Step not found. Please try again.
          </Typography>
        </Box>
      );
    }
    return <Box>{currentStep.component}</Box>;
  };

  return (
    <Box sx={{ flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column'}}>
      <AppBar position="static" sx={{backgroundColor: '#000000'}}>
        <Toolbar>
            <a href={BRANDING.websiteUrl} target='_blank' rel="noopener noreferrer">
              <img src={BRANDING.logoPath} alt={BRANDING.logoAlt} style={{ height: 20, marginRight: 30 }} />
            </a>
            {/* <Typography variant="h6" component="div" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                Plan Your Goals
            </Typography> */}
        </Toolbar>
      </AppBar>

      <Container sx={{ 
        flexGrow: 1, 
        py: 2, 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2,
        // overflow: 'auto', 
        width: {sm:'100%', md:'30%'},
      }}>
        <Box sx={{ p: 1 }}>
          {renderCurrentStep()}
        </Box>
      </Container>

      <Paper square elevation={3} sx={{ position: 'sticky', bottom: 0, width: {sm:'100%', md:'30%'}, margin: {md: '0 auto'}}}>
        <MobileStepper
          variant="text"
          steps={currentTotalSteps}
          position="static"
          activeStep={currentStepIndex}
          sx={{ 
            maxWidth: '100%',
            bgcolor: '#000000',
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2
          }}
          nextButton={
            <IconButton 
              size="small" 
              onClick={handleNext} 
              // disabled={currentStepIndex >= currentTotalSteps - 1}
              disabled={
                currentStepIndex >= currentTotalSteps - 1 ||
                ['Experience', 'Submit', 'Funding Status'].includes(currentSteps[currentStepIndex]?.label) ||
                (currentSteps[currentStepIndex]?.label === 'Kids' && !state.kidsPlanningValid) ||
                (currentSteps[currentStepIndex]?.label === 'Birth Year' && (
                  !state.birthYear ||
                  state.age < 18 ||
                  state.age > 85
                )) ||
                currentSteps[currentStepIndex]?.label === 'Risk Profile' && !state.riskProfile   
              }
              
              sx={{
                color: (currentStepIndex >= currentTotalSteps - 1) ? 'gray' : 'white',
                '&.Mui-disabled': { color: 'grey' }
              }}
            >
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
          }
          backButton={
            <IconButton 
              size="small" 
              onClick={handlePrev} 
              disabled={currentStepIndex === 0}
              sx={{
                color: currentStepIndex === 0 ? 'gray' : 'white',
                '&.Mui-disabled': { color: 'grey' }
              }}
            >
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              Back
            </IconButton>
          }
        />
      </Paper>
    </Box>
  );
};

export default QuestionaryPage;
